<a class="flex justify-center items-center gap-x-3 h-7 w-fit" href="https://www.anecdotes.ai" target="_blank">
  <span class="font-main text-base text-navy-70">{{ 'poweredByLink' | translate }}</span>

  <svg-icon class="h-full" [src]="'mobile/logotype_onwhite'"></svg-icon>
</a>
